import axios from 'axios';
const md5 = require('md5');
const baseURL = process.env.VUE_APP_Event;
import {tId } from '.';
import {
  terminalFn,
  getTrafficTag,
} from './index';
const key = process.env.VUE_APP_key ==='prod' ? '+`98fhD$bzmZ|~5c':'111111';
let ua = 'xyf-mobile-frontend';
const signKey = `${ua}${key}${ua}`;

let id = tId();
export const eventPost = axios.create({
  baseURL: baseURL,
  headers: { 'inner-app':'xyf01','app':'xyf01','App-Name': 'XYF01', Os: terminalFn(), 'Version-code': 40000, 'source-type': 'wap' ,'device-id':''},
  timeout: 10000,
});
// console.dir(appAndH5);
// console.dir(appAndH5.head);

eventPost.interceptors.request.use(
  function(config) {
    // 在发送请求之前做些什么
    // window.tokenFromNative = 'f860599f6168d16aed1cb93166ec1c8a';
    let token = sessionStorage.getItem('token');
    if (window.tokenFromNative && window.tokenFromNative != 'undefined') {
      config.headers.Token = window.tokenFromNative;
    } else if (token) {
      config.headers.Token = token;
    }
    let postdata = {
      ua: 'xyf-mobile-frontend',
      args: {},
      sign: {},
      timestamp: new Date().getTime(),
    };
    // console.log('--------------config.headers-----------------', config.headers);
    let REPORTTOKEN = localStorage.getItem('REPORT_TOKEN');
    let REPORTAPP = localStorage.getItem('REPORT_APP');
    let appName = sessionStorage.getItem('app_name');
    if(appName){
      config.headers['App-Name'] = appName;
      config.headers['app'] = appName;
      config.headers['inner-app'] = appName;
    }
    if (REPORTTOKEN) {
      config.headers.Token = REPORTTOKEN;
    }
    if (REPORTAPP) {
      config.headers['App-Name'] = REPORTAPP;
      config.headers['app'] = REPORTAPP;
      config.headers['inner-app'] = REPORTAPP;
    }
    const trafficTag = getTrafficTag();
    if (trafficTag) config.headers['traffic-tag'] = trafficTag;
    // const { callFlag, call } = config.data;
    // alert(J config.data)
 
    // alert(JSON.stringify(config.data))
    config.data.is_encrypt = 0;
    let args = JSON.stringify(config.data);
    let call = 'event/report';
    let str = `${signKey}${call}${signKey}${args}${signKey}`;
    let sign = md5(str);
    postdata.sign = sign;
    postdata.args = config.data;
    config.data = postdata;
    console.log(config.data,'wrrrrrrr')
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
eventPost.interceptors.response.use(
  response => {
    const responseData = response.data;
    return responseData;
  },
  error => Promise.reject(error)
);

export const fetchEvent = (params)=>{
  let baseURL  = process.env.VUE_APP_Event +'/event/report';
  let headers =  { 'inner-app':'xyf','app':'xyf','App-Name': 'XYF', Os: terminalFn(), 'Version-code': 40000, 'source-type': 'wap' ,'device-id':''};
  let token = sessionStorage.getItem('token');
  if (window.tokenFromNative && window.tokenFromNative != 'undefined') {
    headers.Token = window.tokenFromNative;
  } else if (token) {
   headers.Token = token;
  }
  let postdata = {
    ua: 'xyf-mobile-frontend',
    args: {},
    sign: {},
    timestamp: new Date().getTime(),
  };
  // console.log('--------------config.headers-----------------', config.headers);
  let REPORTTOKEN = localStorage.getItem('REPORT_TOKEN');
  let REPORTAPP = localStorage.getItem('REPORT_APP');
  let appName = sessionStorage.getItem('app_name');
  if(appName){
    headers['App-Name'] = appName;
    headers['app'] = appName;
    headers['inner-app'] = appName;
  }
  if (REPORTTOKEN) {
    headers.Token = REPORTTOKEN;
  }
  if (REPORTAPP) {
    headers['App-Name'] = REPORTAPP;
    headers['app'] = REPORTAPP;
    headers['inner-app'] = REPORTAPP;
  }
  params.is_encrypt = 0;
  let args = JSON.stringify(params);
  let call = 'event/report';
  let str = `${signKey}${call}${signKey}${args}${signKey}`;
  let sign = md5(str);
  postdata.sign = sign;
  postdata.args = params;
  console.log(postdata,'rw')
  fetch( baseURL, {
    method: 'POST',
    headers:headers,
    body:JSON.stringify(postdata),
    keepalive: true
  });
}
